import React from "react";
import { Link } from "react-router-dom";

const FeedbackSuccess = () => {
  return (
    <div className="flex items-center justify-center h-screen">
      <div className="bg-white p-6 rounded-2xl shadow-lg text-center max-w-md">
        <h2 className="text-2xl font-bold text-green">Thank You! 🎉</h2>
        <p className="text-darkGray mt-3">
          Your feedback has been submitted successfully. We appreciate your time
          and valuable input!
        </p>
        <button className="mt-5 px-4 py-2 bg-green text-white rounded-lg  transition">
          <Link to="/">Back to Home</Link>
        </button>
      </div>
    </div>
  );
};

export default FeedbackSuccess;
